import { render, staticRenderFns } from "./CommunityAdd.vue?vue&type=template&id=625b270c&scoped=true"
import script from "./CommunityAdd.vue?vue&type=script&lang=js"
export * from "./CommunityAdd.vue?vue&type=script&lang=js"
import style0 from "./CommunityAdd.vue?vue&type=style&index=0&id=625b270c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625b270c",
  null
  
)

export default component.exports